<dx-popup
  id="dialog-creation-bon-reception"
  [visible]="popupVisible()"
  [height]="'auto'"
  [maxWidth]="990"
  [showCloseButton]="false"
  [wrapperAttr]="{ class: 'creation-br-popup' }">

  <div *dxTemplate="let _ of 'title'" class="creation-br-header">
    <div>
      <strong> Créer un bon de réception pour la commande {{ bonCf()?.numeroBcf }}</strong>
    </div>

    <div class="creation-br-actions">
      <yo-button iconClass="fas fa-plus"
                 [theme]="ButtonThemeEnum.ADD"
                 tooltip="Créer le bon de réception"
                 (onClick)="save()">
      </yo-button>
      <yo-button iconClass="fas fa-times"
                 tooltip="Fermer"
                 (onClick)="close()"
                 [theme]="ButtonThemeEnum.CANCEL">
      </yo-button>
    </div>
  </div>

  <section *dxTemplate="let _ of 'content'" class="creation-br-content">
    <form [formGroup]="form()" novalidate class="creation-br-sections">

      <div class="creation-br-column">
        <span class="creation-br-section-title"><strong>Bon de réception</strong></span>
        <div class="creation-br-list">

          <div class="creation-br-row">
            <span>N° bon de réception</span>
            <yo-text-box
              [value]="form().controls['numeroBonReception']?.value"
              [readonly]="true"
              [disabled]="true">
            </yo-text-box>
          </div>

          <div class="creation-br-row">
            <span>N° bon de livraison</span>
            <yo-text-box
              [value]="form().controls['numeroBonLivraison']?.value"
              (onValueChanged)="form().controls['numeroBonLivraison']?.setValue($event)">
            </yo-text-box>
          </div>

          <div class="creation-br-row">
            <span>Date de livraison <span class="danger-color">*</span></span>
            <yo-date-picker
              [value]="form().controls['dateLivraison']?.value"
              (onValueChange)="form().controls['dateLivraison']?.setValue($event)">
            </yo-date-picker>
          </div>

        </div>
      </div>

      <div class="creation-br-column">
        <span class="creation-br-section-title"><strong>Contrôle à réception</strong></span>
        <div class="creation-br-list">

          <div class="creation-br-row">
            <span>Livreur</span>
            <yo-text-box
              [value]="form().controls['livreur']?.value"
              (onValueChanged)="form().controls['livreur']?.setValue($event)">
            </yo-text-box>
          </div>

          <div class="creation-br-row">
            <span>Immatriculation</span>
            <yo-text-box
              [value]="form().controls['immatriculation']?.value"
              (onValueChanged)="form().controls['immatriculation']?.setValue($event)">
            </yo-text-box>
          </div>

          <div class="creation-br-row">
            <span>Température du camion</span>
            <div class="creation-br-text-box">
              <yo-number-box
                [value]="form().controls['temperatureCamion']?.value"
                (onValueChanged)="form().controls['temperatureCamion']?.setValue($event)">
              </yo-number-box>
              <strong>° Celsius</strong>
            </div>
          </div>

          <div class="creation-br-row">
            <span>Livraison non-conforme</span>
            <yo-tagbox
              [data]="mncSvc.motifsNonConfoEnvironnement"
              [selectedItems]="selectedMotifIdList()"
              [displayValue]="'libelle'"
              [maxDisplayedTags]="3"
              [tooltipExpr]="'libelle'"
              [dropDownOptions]="{ wrapperAttr: { class: 'yo-tagbox-dropdown' } }"
              (onValueChange)="selectedMotifIdList.set($event)">
            </yo-tagbox>
          </div>

        </div>
      </div>

    </form>
  </section>

</dx-popup>
